import { render, staticRenderFns } from "./ImportExcelToJson.vue?vue&type=template&id=2d0a2ae4&scoped=true&"
import script from "./ImportExcelToJson.vue?vue&type=script&lang=js&"
export * from "./ImportExcelToJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a2ae4",
  null
  
)

export default component.exports